(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hubspot-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function loadHubspotScript(region, callback) {
      if (window.hbspt) {
        callback();
        return;
      }
      window.__hubspotFormCallbacks = window.__hubspotFormCallbacks || [];
      window.__hubspotFormCallbacks.push(callback);
      if (window.__hubspotScriptLoading) {
        return;
      }
      window.__hubspotScriptLoading = true;
      var script = document.createElement('script');
      script.src = 'https://js-' + region + '.hsforms.net/forms/embed/v2.js';
      script.charset = 'utf-8';
      script.onload = function () {
        window.__hubspotFormCallbacks.forEach(function (cb) {
          cb();
        });
        window.__hubspotFormCallbacks = [];
      };
      document.head.appendChild(script);
    }

    // HubSpot styles each form from its own form-editor theme, so forms built
    // at different times disagree — blue Questrial labels on one, black Inter
    // on another, HubSpot-blue buttons on both, none of it the site's look
    // (BugHerd #179, and #120 for the button size). The form renders in a
    // same-origin iframe, so drop one stylesheet into it that restyles every
    // HubSpot form the same way, from the theme's own design tokens (read off
    // the parent page so they follow theme settings). `!important` because
    // HubSpot's per-form rules stack several classes onto each selector.
    function themeCss() {
      var root = getComputedStyle(document.documentElement);
      function token(name, fallback) {
        return root.getPropertyValue(name).trim() || fallback;
      }
      var font = token('--font-body--family', '"Helvetica Neue", Helvetica, Arial, sans-serif');
      var heading = token('--color-heading', '#002652');
      var text = token('--color-text', '#4a4c4e');
      var muted = token('--color-text-muted', '#697077');
      var ink = token('--color-foreground', '#0f1922');
      var primary = token('--color-primary', '#83b900');
      var ground = token('--color-background', '#ffffff');
      var radius = token('--style-border-radius-inputs', '8px');

      return [
        '.hs-form, .hs-form fieldset, .hs-form .hs-richtext, .hs-form p {',
        '  font-family: ' + font + ' !important; color: ' + text + ' !important;',
        '}',
        '.hs-form fieldset { max-width: none !important; }',
        '.hs-form .hs-form-field { margin-bottom: 18px !important; }',
        '.hs-form .hs-form-field > label, .hs-form legend.hs-field-desc {',
        '  font-family: ' + font + ' !important;',
        '}',
        '.hs-form .hs-form-field > label {',
        '  display: block !important; margin-bottom: 6px !important;',
        '  font-size: 15px !important; font-weight: 600 !important; line-height: 1.4 !important;',
        '  color: ' + heading + ' !important; text-transform: none !important; letter-spacing: normal !important;',
        '}',
        '.hs-form legend.hs-field-desc { padding: 0 !important; margin-bottom: 6px !important; font-size: 14px !important; color: ' + muted + ' !important; }',
        '.hs-form .hs-form-required { color: ' + heading + ' !important; }',
        '.hs-form .hs-input:not([type=checkbox]):not([type=radio]):not([type=file]) {',
        '  box-sizing: border-box !important; width: 100% !important; height: 48px !important;',
        '  padding: 12px 16px !important; border: 0 !important; border-radius: ' + radius + ' !important;',
        '  background: ' + ground + ' !important; box-shadow: inset 0 0 0 1px rgba(15, 25, 34, 0.15) !important;',
        '  font-family: ' + font + ' !important; font-size: 16px !important; line-height: 1.5 !important; color: ' + ink + ' !important;',
        '}',
        '.hs-form textarea.hs-input { height: auto !important; min-height: 120px !important; }',
        '.hs-form .hs-input:focus { outline: none !important; box-shadow: inset 0 0 0 2px ' + primary + ' !important; }',
        '.hs-form .hs-input::placeholder { color: ' + muted + ' !important; opacity: 1 !important; }',
        '.hs-form .hs-input.invalid.error { box-shadow: inset 0 0 0 2px #c0392b !important; }',
        '.hs-form .hs-error-msgs label, .hs-form .hs-error-msg { font-size: 14px !important; font-weight: 400 !important; color: #c0392b !important; }',
        '.hs-form .inputs-list label, .hs-form .hs-form-booleancheckbox-display, .hs-form .hs-form-checkbox-display {',
        '  font-family: ' + font + ' !important; font-size: 15px !important; font-weight: 400 !important; color: ' + text + ' !important;',
        '}',
        '.hs-form input[type=checkbox], .hs-form input[type=radio] { accent-color: ' + primary + ' !important; }',
        '.hs-form .hs-button {',
        '  padding: 12px 26px !important; border: 0 !important; border-radius: ' + radius + ' !important;',
        '  background: ' + primary + ' !important; box-shadow: inset 0 0 0 2px ' + primary + ' !important; color: ' + ground + ' !important;',
        '  font-family: ' + font + ' !important; font-size: 17px !important; font-weight: 700 !important; line-height: 1.5 !important;',
        '  text-transform: none !important; letter-spacing: normal !important; cursor: pointer !important;',
        '  transition: background-color 0.18s ease !important;',
        '}',
        '.hs-form .hs-button:hover, .hs-form .hs-button:focus-visible {',
        '  background: color-mix(in srgb, ' + primary + ', white 12%) !important;',
        '}',
      ].join('\n');
    }

    function applyThemeStyles($form) {
      var form = $form && $form.jquery ? $form[0] : $form;
      if (!form || !form.ownerDocument) {
        return;
      }
      var doc = form.ownerDocument;
      if (doc.getElementById('theme-hubspot-overrides')) {
        return;
      }
      var style = doc.createElement('style');
      style.id = 'theme-hubspot-overrides';
      style.textContent = themeCss();
      doc.head.appendChild(style);
    }

    document.querySelectorAll('[data-hubspot-form]').forEach(function (container) {
      var region = container.dataset.region;

      loadHubspotScript(region, function () {
        hbspt.forms.create({
          portalId: container.dataset.portalId,
          formId: container.dataset.formId,
          region: region,
          target: '#' + container.id,
          onFormReady: function ($form) {
            applyThemeStyles($form);

            var queryParam = container.dataset.prefillQueryParam;
            var fieldName = container.dataset.prefillField;
            if (!queryParam || !fieldName) {
              return;
            }
            var value = new URLSearchParams(window.location.search).get(queryParam);
            if (value) {
              $form.find('[name="' + fieldName + '"]').val(value);
            }
          },
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
